export function changeHomeScreenState(resp) {
    return {
        type: 'CHANGE',
        payload: resp
    };
}
